import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Helpers } from 'shared-components/helpers/helpers';
import { ArrowBack, ArrowDown } from 'shared-components/icons';
import { useScrollLock } from 'shared-components/utils/hooks/use-scroll-lock';

export const SpaceSelector = ({ spaces = [], onSpaceSelected }) => {
  const [selectedSpace, setSelectedSpace] = useState(spaces[0]);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const isMobile = Helpers.isMobile(false, true);

  const { setScrollLocked } = useScrollLock();

  const handleSpaceSelected = (space) => {
    if (space._id === selectedSpace._id) {
      return;
    }
    setSelectedSpace(space);
    !!onSpaceSelected && onSpaceSelected(space);
  };

  useEffect(() => {
    const closeDropdown = () => {
      setDropdownVisible(false);
    };
    if (dropdownVisible) {
      document.addEventListener('click', closeDropdown);
    }
    return () => {
      document.removeEventListener('click', closeDropdown);
    };
  }, [dropdownVisible]);

  useEffect(() => {
    if (!isMobile) {
      return;
    }
    setScrollLocked(dropdownVisible);
  }, [dropdownVisible]);

  return (
    <div
      className='relative space-selector-container'
      style={{ width: '443px', height: '86px', maxWidth: '100%' }}
    >
      <button
        className='border border-radius-sm padding-lg text-left flex middle'
        style={{ width: '100%', height: '100%' }}
        onClick={() => setDropdownVisible((prev) => !prev)}
      >
        <div className='padding-lg-right ellipsis flex-one'>
          <p className='h4 ellipsis no-margin'>{selectedSpace.title}</p>
          <span className='text-gray-600 ellipsis margin-sm-top inline-block'>
            {selectedSpace.street}
          </span>
        </div>
        <ArrowDown width='24px' height='24px' />
      </button>
      <div
        className={classNames('space-selector-dropdown', {
          'is-mobile': isMobile
        })}
        style={{
          display: dropdownVisible ? 'block' : 'none'
        }}
      >
        {isMobile && (
          <div className='flex middle padding-lg' style={{ height: '60px' }}>
            <span
              role='button'
              className='flex middle'
              style={{ cursor: 'pointer' }}
              onClick={() => setDropdownVisible(false)}
            >
              <ArrowBack width='24px' height='24px' />
            </span>
            <p className='h4 margin-md-left margin-no-top margin-no-bottom'>
              <FormattedMessage
                id='space_selector.choose_a_space'
                defaultMessage='Choose a space'
              />
            </p>
          </div>
        )}
        <ul role='listbox'>
          {spaces.map((space) => (
            <li
              key={space._id}
              role='option'
              className={classNames(
                'padding-lg space-selector-list-item border-bottom',
                {
                  selected: space._id === selectedSpace._id
                }
              )}
              onClick={() => handleSpaceSelected(space)}
            >
              <p
                className={classNames(
                  'ellipsis no-margin',
                  isMobile ? 'h6' : 'h4'
                )}
              >
                {space.title}
              </p>
              <span className='text-gray-600 ellipsis margin-sm-top inline-block'>
                {space.street}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
